import {routerConfig} from "./RouterConfig";

import Common from "./common";
import IvStore from "./iv";
import IInvestStore from "./iinvest";
import TfStore from "./tf";

const rootDir = "app/store";

export default angular.module("tfApp.store", [Common(rootDir), IvStore(rootDir), IInvestStore(rootDir), TfStore(rootDir)])
                      .config(routerConfig)
                      .name;
